import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Upload, DatePicker, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';

const NewsForm = ({ initialValues, onSuccess }) => {
    const [form] = Form.useForm();
    const [fileList, setFileList] = useState([]);

    useEffect(() => {
        if (initialValues) {
            const newInitialValues = {
                ...initialValues,
                published_date: initialValues.published_date ? dayjs(initialValues.published_date) : null,
                deadline_date: initialValues.deadline_date ? dayjs(initialValues.deadline_date) : null,
            };

            if (typeof initialValues.image === 'string') {
                newInitialValues.image = [
                    {
                        uid: '-1',
                        name: 'image.jpg',
                        status: 'done',
                        url: process.env.REACT_APP_API_BASE_URL + `${initialValues.image}`,
                    },
                ];
            }

            form.setFieldsValue(newInitialValues);
        } else {
            form.resetFields();
        }
    }, [initialValues, form]);

    const handleFinish = async (values) => {
        const formData = new FormData();
        formData.append('title_id', values.title_id);
        formData.append('title_en', values.title_en);
        formData.append('description_id', values.description_id);
        formData.append('description_en', values.description_en);
        formData.append(
            'published_date',
            values.published_date ? values.published_date.format('YYYY-MM-DD') : ''
        ); if (fileList.length > 0) {
            formData.append('image', fileList[0].originFileObj);
        }
        await onSuccess(formData);
        form.resetFields();
    };

    return (
        <Form
            form={form}
            layout="vertical"
            onFinish={handleFinish}
        // initialValues={{
        //     title: initialValues?.title || '',
        //     description: initialValues?.description || '',
        // }}
        >
            <Form.Item
                label="Title ID"
                name="title_id"
            // rules={[{ required: true, message: 'Judul harus diisi' }]}
            >
                <Input placeholder='Masukkan judul artikel' />
            </Form.Item>

            <Form.Item
                label="Title EN"
                name="title_en"
            // rules={[{ required: true, message: 'Judul harus diisi' }]}
            >
                <Input placeholder='Masukkan judul artikel' />
            </Form.Item>

            <Form.Item
                label="Description ID"
                name="description_id"
            // rules={[{ required: true, message: 'Deskripsi harus diisi' }]}
            >
                <Input placeholder='Masukkan deskripsi artikel' />
            </Form.Item>

            <Form.Item
                label="Description EN"
                name="description_en"
            // rules={[{ required: true, message: 'Deskripsi harus diisi' }]}
            >
                <Input placeholder='Masukkan deskripsi artikel' />
            </Form.Item>

            <Form.Item
                label="Published Date"
                name="published_date"
                rules={[{ required: true }]}>
                <DatePicker style={{ width: '100%' }} />
            </Form.Item>

            <Form.Item
                label="Image"
                name="image"
            // valuePropName="file"
            // getValueFromEvent={(e) => (Array.isArray(e) ? e : e && e.fileList[0])}
            >
                <Upload
                    beforeUpload={() => false}
                    fileList={fileList}
                    onChange={({ fileList }) => setFileList(fileList)}
                    maxCount={1}
                >
                    <Button icon={<UploadOutlined />}>Upload Gambar</Button>
                </Upload>
            </Form.Item>

            <Form.Item style={{ textAlign: 'right' }}>
                <Button
                    htmlType="submit"
                    style={{
                        backgroundColor: '#ec4899',
                        borderColor: '#ec4899',
                        color: '#fff',
                    }}
                >
                    Simpan
                </Button>
            </Form.Item>
        </Form>
    );
};

export default NewsForm;
